import * as __WEBPACK_EXTERNAL_MODULE_tailwind_variants_6759ef11__ from "tailwind-variants";
import * as __WEBPACK_EXTERNAL_MODULE__utils_tailwind_merge_js_13b5c6ed__ from "../utils/tailwind-merge.js";
const tv = (0, __WEBPACK_EXTERNAL_MODULE_tailwind_variants_6759ef11__.createTV)({
    twMergeConfig: __WEBPACK_EXTERNAL_MODULE__utils_tailwind_merge_js_13b5c6ed__.twMergeConfig
});
export { tv };
